import React from "react";
import ExperienceDiv from "../css/Experience.styled";
import { Fade } from "react-awesome-reveal";

const experiences = [
  {
    company: "Napino Auto & Electronics Pvt. Ltd.",
    role: "Supply Chain Coordinator (Freelancer)",
    period: "Sep 2020 – Mar 2022",
    location: "Gurgaon, India",
    achievements: [
      "Managed production and raw-material data in SAP while coordinating with Planning, Procurement, Stores, and Production teams to ensure smooth operations.",
      "Supported manufacturing execution by tracking inventory, material flow, and production schedules to prevent shortages and delays.",
      "Created and standardized Work Instructions (WI) and Standard Operating Procedures (SOPs) for every stage of the SMT process, boosting clarity and consistency.",
    ],
  },
  {
    company: "Prismforce Pvt. Ltd.",
    tagline: "Sequoia-backed AI vertical SaaS",
    role: "ASDE → SDE-1",
    period: "Feb 2023 – Present",
    location: "Bangalore, India",
    achievements: [
      "Dashboards & Reports: Conducted POCs for Redshift and TimescaleDB, then optimized the platform on PostgreSQL RDS with tuned queries and interconnected MVs. Re-architected the module using Snowflake, Golang stream pipelines, and DuckDB, migrating complex MongoDB/PostgreSQL workloads to Snowflake SQL for 10× faster APIs and 9× faster report generation while trimming infrastructure usage.",
      "Data Migration: Overhauled large-scale ETL for dashboards and reports (~30M records per entity) using Delta processing, Argo Workflows, DAG orchestration, Docker, AWS S3, Parquet, Golang, and Snowflake Stage, reducing runtime from 15 hours to 1 hour.",
      "On-Demand Compute: Delivered scalable report execution with AWS SQS, Kubernetes Scaled Jobs, S3, SNS, and ArgoCD, cutting compute costs by 60%.",
      "User Engagements: Built the Avatars module with admin CRUD and multi-region synchronization, and co-designed APIs plus scheduled jobs for the Badges program.",
      "OutlookPrism: Developed the MVP-1 end-to-end from the ground up.",
    ],
  },
];

const Experience = () => {
  return (
    <ExperienceDiv id="experience">
      <p className="title">Experience</p>
      <div className="experienceList">
        <span className="experienceFlow" aria-hidden />
        <span className="experienceFlowArrow" aria-hidden />
        {experiences.map((exp) => (
          <Fade key={exp.company} direction="up" duration={700} triggerOnce>
            <article className="experienceCard">
              <header className="experienceHeader">
                <div>
                  <h3>{exp.company}</h3>
                  {exp.tagline ? (
                    <p className="tagline">{exp.tagline}</p>
                  ) : null}
                </div>
                <div className="meta">
                  <p>{exp.role}</p>
                  <p>{exp.period}</p>
                  <p>{exp.location}</p>
                </div>
              </header>
              <ul>
                {exp.achievements.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          </Fade>
        ))}
      </div>
    </ExperienceDiv>
  );
};

export default Experience;
